"use client";

import { motion } from "motion/react";

export const MotionDiv = motion.div;
export const MotionP = motion.p;
export const MotionH1 = motion.h1;
export const MotionH2 = motion.h2;
export const MotionH3 = motion.h3;
export const MotionSpan = motion.span;
export const MotionUl = motion.ul;
export const MotionLi = motion.li;
export const MotionSection = motion.section;
export const MotionButton = motion.button;

export {
  LazyMotion,
  domAnimation,
  useInView,
  useMotionValue,
  useSpring,
  useTransform,
  AnimatePresence,
  useAnimation,
} from "motion/react";
